export class JourneyStreamHelper {
  public static subscribeToJourneyPrognosis(vehiclePositionsStreamUrl: string, serviceJourneyGid: string, onSnapshot: (data: string) => void, onUnavailable: () => void): () => void {
    let source: EventSource | undefined;
    let retryTimer: ReturnType<typeof setTimeout> | undefined;
    let disposed = false;

    const connect = () => {
      if (disposed || document.hidden) return;
      const url = new URL(vehiclePositionsStreamUrl);
      url.pathname = `${url.pathname}/prognosis`;
      url.search = '';
      url.searchParams.set('serviceJourneyGid', serviceJourneyGid);
      const connection = new EventSource(url.toString());
      source = connection;
      connection.addEventListener('snapshot', (event: MessageEvent<string>) => {
        if (!disposed && source === connection) onSnapshot(event.data);
      });
      connection.addEventListener('unavailable', () => {
        if (!disposed && source === connection) onUnavailable();
      });
      connection.onerror = () => {
        if (disposed || source !== connection) return;
        connection.close();
        source = undefined;
        onUnavailable();
        // NV-8679: close native automatic retries, including rejected connections, and back off.
        retryTimer = setTimeout(connect, 30000);
      };
    };

    const visibilityChanged = () => {
      source?.close();
      source = undefined;
      clearTimeout(retryTimer);
      onUnavailable();
      if (!document.hidden) connect();
    };
    document.addEventListener('visibilitychange', visibilityChanged);
    connect();
    return () => {
      disposed = true;
      source?.close();
      clearTimeout(retryTimer);
      document.removeEventListener('visibilitychange', visibilityChanged);
    };
  }
}
